export const PROVIDER_BETA_PATH = "/provider-beta";

export const PROVIDER_BETA_SUCCESS_MESSAGE = "We will reach out to you shortly.";

export const PROVIDER_ROLES = [
  "Therapist",
  "Psychologist",
  "Counselor",
  "Social Worker",
  "Life Coach",
  "Executive Coach",
  "Wellness Practitioner",
  "School Counselor",
  "Other"
];

export const EXPERIENCE_OPTIONS = ["0–2", "3–5", "6–10", "10+"];

export const CLIENT_POPULATIONS = [
  "Anxiety",
  "Stress / Burnout",
  "Relationships",
  "Trauma",
  "Young Adults",
  "Professionals / Leaders",
  "Students",
  "Emotional Regulation",
  "Grief",
  "Other"
];

export const USEFULNESS_OPTIONS = ["Very useful", "Somewhat useful", "Unsure", "Probably not"];

export const FEEDBACK_OPTIONS = ["Yes", "Maybe", "No"];

export const HOW_IT_WORKS_STEPS = [
  { key: "event", title: "Event", subtitle: "What happened?" },
  { key: "interpretation", title: "Interpretation", subtitle: "What story did I tell myself?" },
  { key: "evidence", title: "Evidence", subtitle: "What supports or challenges that belief?" },
  { key: "response", title: "Response", subtitle: "How do I want to move forward?" }
];

export const PROBLEM_BULLETS = [
  "The argument happens",
  "Anxiety returns",
  "Old beliefs reappear",
  "Emotional reactions take over"
];

export const BENEFITS = [
  {
    icon: "◆",
    title: "Support reflection between sessions",
    body: "Clients revisit difficult experiences without waiting for the next appointment."
  },
  {
    icon: "◇",
    title: "Recognize patterns over time",
    body: "Repeated thoughts and emotions become easier to identify."
  },
  {
    icon: "○",
    title: "Prepare for deeper conversations",
    body: "Sessions spend less time reconstructing events."
  },
  {
    icon: "▣",
    title: "Reduce vague memories",
    body: 'Less "I don\'t know what happened."'
  },
  {
    icon: "▤",
    title: "Structured journaling",
    body: "No intimidating blank page."
  },
  {
    icon: "◎",
    title: "Encourage emotional awareness",
    body: "Help clients pause before reacting."
  }
];

export const PROVIDER_TYPES = [
  { title: "Therapists", tags: "LMFT • LPC • CBT Practitioners • Psychologists" },
  { title: "Coaches", tags: "Life Coaches • Executive Coaches • Leadership Coaches" },
  { title: "Wellness Professionals", tags: "Mindfulness Practitioners • Wellness Educators" },
  { title: "Social Workers", tags: "Counselors • Community Mental Health Providers" },
  { title: "School Counselors", tags: "Youth Mentors • Student Support Professionals" }
];

export const SHAPE_CHECKLIST = [
  "Is the framework useful between sessions?",
  "Which clients benefit most?",
  "What language feels supportive and ethical?",
  "What safeguards are needed?",
  "What feedback would providers want to see?"
];

export const BETA_PERKS = [
  "Early access",
  "Ability to influence the product",
  "Direct communication with the founder",
  "Exclusive provider discussions",
  "Future resources and guides"
];

export const FORM_STEPS = [
  "About You",
  "Professional Background",
  "Client Population",
  "Reflection Tool Fit",
  "Beta Commitment"
];
